import styled from "styled-components";
import PanelAreaSource from "./PanelAreaSource/PanelAreaSource";
import { Button } from "@mui/material";
import { useState } from "react";
import {
  PANEL_AREA_SOURCE_NAV_MODES,
  PANEL_AREA_SOURCE_NAV_MODES_LABELS,
} from "./PanelAreaSourceNav.const";
import { nextToggleNavMod } from "./PanelAreaSourceNav.logic";
import { PlaySource } from "type/panel/Panel.type";

type Props = {
  navMode: string;
  setNavMode: Function;
  source: PlaySource[];
  onSourceUpdate: Function;
};

const PanelAreaSourceNav = ({
  navMode,
  setNavMode,
  source,
  onSourceUpdate,
}: Props) => {
  const navModeToggle = () => {
    const nextMode: string = nextToggleNavMod(navMode);
    setNavMode(nextMode);
  };

  return (
    <Div>
      <div>
        mode:
        <Button onClick={navModeToggle}>
          {PANEL_AREA_SOURCE_NAV_MODES_LABELS[navMode]}
        </Button>
      </div>
      {navMode === PANEL_AREA_SOURCE_NAV_MODES.CONTENT && (
        <DivSource>
          <PanelAreaSource source={source} onSourceUpdate={onSourceUpdate} />
        </DivSource>
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const DivSource = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default PanelAreaSourceNav;
